<div class="row d-flex flex-column px-5 p-md-0 justify-content-center my-5">
  <div class="d-flex justify-content-center">
    <div class="border-green rounded col-md-12 col-sm-11 p-0">
      <div class="d-flex p-4">
        <div class="w-100 p-0 d-md-flex align-items-center">
          <div class="col-xs-12 col-md-5 col-lg-3 d-flex justify-content-start align-items-center">
            <img alt="correct_check_circle" src="../../../../assets/images/cibil/correct_check_circle.svg" />
            <span class="text-success ml-3">
              Pre-approved <br class="d-none d-md-block" />
              Loan Offer
            </span>
          </div>

          <div class="col-xs-12 col-md-4 col-lg-6 text-left my-md-0 my-4">
            <p class="mb-0">Hurray !!! You have a pre approved Loan offer.</p>
            <p class="mb-0">Below are the loan details</p>
          </div>
          <div
            class="col-xs-12 col-md-3 mt-sm-4 mb-sm-3 pl-lg-0 pr-lg-5 d-flex justify-content-md-end align-items-center">
            <button mat-flat-button class="primary p-0 m-0" (click)="navigateToLoanInfo()">
              APPLY NOW
            </button>
          </div>
        </div>
      </div>
      <div class="d-flex bg-grey p-4">
        <div class="w-100">
          <div class="col-lg-3 col-12 col-sm-6 d-flex flex-column justify-content-center my-3">
            <p class="mb-1">Loan Amount</p>
            <p class="font-weight-900 mb-0">₹ {{indicativeLoan.amount | number : '1.2-2'}}</p>
          </div>
          <div class="col-lg-3 col-12 col-sm-6 d-flex flex-column justify-content-center my-3">
            <p class="mb-1">Tenure</p>
            <p class="font-weight-900 mb-0">{{indicativeLoan.tenure}} months</p>
          </div>
          <div class="col-lg-3 col-12 col-sm-6 d-flex flex-column justify-content-center my-3">
            <p class="mb-1">Interest Rate (Reducing Balance)</p>
            <p class="font-weight-900 mb-0">{{indicativeLoan.rateOfInterest}}% p.a.</p>
          </div>
          <div class="col-lg-3 col-12 col-sm-6 d-flex flex-column justify-content-center my-3">
            <p class="mb-1">Indicative EMI Amount</p>
            <p class="font-weight-900 mb-0">₹ {{indicativeLoan.emi | number : '1.2-2'}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-2 mb-5 p-lg-0 px-md-5 text-justify">
    *This offer is subject to successful KYC clearance and final credit approval
  </div>
</div>